<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn class="v-primary mb-1" v-on:click="handleModalCreate">
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create -->
        <b-modal id="createTypeOfMedicine" hide-footer>
          <template v-slot:modal-title>Novo tipo de medicamento</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create -->
        <v-card>
          <v-card-title>
            Tipos de medicamento
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="typeOfMedicines"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <!-- Modal alterar typeOfMedicine -->
              <b-modal :id="String(item.id)" hide-footer>
                <template v-slot:modal-title
                  >Editar tipo de medicamento</template
                >
                <div class="d-block">
                  <div class="container">
                    <b-overlay
                      :show="loadingTypeOfMedicineUpdate"
                      opacity="0.99"
                    >
                      <form v-on:submit="update" method="post">
                        <div class="row">
                          <WarningRequiredFields />
                          <ErrorsMessages :errors="errors" />
                          <div class="col-md-12">
                            <LabelRequiredField label="Nome" />
                            <input
                              type="text"
                              v-model="name"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12">
                            <h6>
                              <span class="text-muted">Criação:</span>
                              {{ formatDate(item.created_at) }}
                            </h6>
                            <h6>
                              <span class="text-muted">Última alteração:</span>
                              {{ formatDate(item.updated_at) }}
                            </h6>
                          </div>
                          <div class="col-md-12 text-right">
                            <v-btn
                              :disabled="loadingUpdate"
                              type="submit"
                              class="v-success m-1"
                            >
                              <span class="fa fa-check"></span>
                              {{ loadingUpdate ? "Carregando" : "Salvar" }}
                            </v-btn>
                            <v-btn
                              class="v-danger m-1"
                              v-confirm="{
                                html: true,
                                loader: false,
                                ok: (dialog) =>
                                  deleteTypeOfMedicine(dialog, item),
                                cancel: () => {},
                                message:
                                  'Deseja realmente apagar o tipo de medicamento? <hr /> Só pode apagar caso não exista vinculo do tipo de medicamento com medicamento!',
                                okText: 'Confirmar',
                                cancelText: 'Cancelar',
                              }"
                            >
                              <span class="fa fa-times-circle"></span> Apagar
                            </v-btn>
                          </div>
                        </div>
                      </form>
                    </b-overlay>
                  </div>
                </div>
              </b-modal>
              <!-- /Modal alterar typeOfMedicine -->
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import api from "../services/api";
import toast from "../components/ToastNotification";
import { formatDate } from "../functions/format";

export default {
  name: "TypeOfMedicine",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],
      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Nome", value: "name" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      typeOfMedicine: {},
      typeOfMedicines: [],
      id: "",
      name: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingTypeOfMedicineUpdate: false,
      loading: true,
    };
  },
  async created() {
    this.getTypeOfMedicines();
  },
  methods: {
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];
      this.handleModalTypeOfMedicine(item.id);
      this.$bvModal.show(String(item.id));
    },
    async getTypeOfMedicines(page = 1) {
      try {
        this.loading = true;

        const response = await api.get("/admin/type-of-medicine/paginate", {
          params: { page },
        });

        const { types } = response.data;

        this.typeOfMedicines = types;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { name } = this;

        let params = {
          name,
        };

        const response = await api.post(
          "/admin/type-of-medicine/create",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("createTypeOfMedicine");
          this.getTypeOfMedicines();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, name } = this;

        let params = {
          id,
          name,
        };

        const response = await api.put(
          "/admin/type-of-medicine/update",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(String(id));
          this.getTypeOfMedicines();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.$bvModal.show("createTypeOfMedicine");
    },
    async handleModalTypeOfMedicine(id) {
      try {
        this.loadingTypeOfMedicineUpdate = true;

        this.id = id;

        const response = await api.get("/admin/type-of-medicine/get", {
          params: { id },
        });

        const { type } = response.data;

        this.typeOfMedicine = type;
        this.id = type.id;
        this.name = type.name;
        this.loadingTypeOfMedicineUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteTypeOfMedicine(dialog, typeOfMedicine) {
      try {
        const { id } = typeOfMedicine;

        let data = { id };

        const response = await api.delete("/admin/type-of-medicine/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getTypeOfMedicines();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>